import React from "react";
import { motion } from "framer-motion";
import { Btn, Eyebrow } from "../components/Primitives";
import Logo from "../components/Logo";

export default function PostPurchase({ user, foundingNumber, onContinue, onOpenMembership }) {
    const num = foundingNumber || user?.founding_member_number;

    return (
        <div className="flex-1 flex flex-col bg-cream" data-testid="post-purchase-screen">
            <div className="px-6 pt-8 pb-2 flex justify-start">
                <Logo size={56} />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="flex-1 flex flex-col justify-center px-7"
            >
                <Eyebrow className="mb-5">You're in</Eyebrow>
                <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] text-burgundy tracking-tight">
                    <span className="italic">You're</span> Founding Member #{num || "—"}.
                </h1>

                <p className="mt-6 font-display italic text-xl text-ink leading-snug">
                    Welcome to Ever After.
                </p>

                <div className="mt-6 editorial-rule" />

                <p className="mt-6 text-base text-ink leading-relaxed">
                    Your $99 founding fee is locked in as a credit toward any subscription tier at our official launch. Until then, your full access continues at no additional charge.
                </p>
                <p className="mt-4 text-sm text-ink-muted leading-relaxed">
                    We'll email you a receipt and your founding member confirmation. You can review your founding terms anytime under{" "}
                    <button
                        data-testid="post-purchase-membership-link"
                        onClick={onOpenMembership}
                        className="underline underline-offset-2 text-burgundy"
                    >
                        Settings → Membership
                    </button>
                    .
                </p>
            </motion.div>

            <div className="px-6 pb-10">
                <Btn data-testid="post-purchase-reveal-btn" onClick={onContinue}>
                    Reveal my archetype
                </Btn>
            </div>
        </div>
    );
}
